import { render, staticRenderFns } from "./TrainingCourse.vue?vue&type=template&id=b0827870&scoped=true"
import script from "./TrainingCourse.vue?vue&type=script&lang=js"
export * from "./TrainingCourse.vue?vue&type=script&lang=js"
import style0 from "./TrainingCourse.vue?vue&type=style&index=0&id=b0827870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0827870",
  null
  
)

export default component.exports